import { Component } from '@angular/core';
import { AccessControlRole, SIDEMENU_CONFIG, SidemenuComponent } from '@lib-ui';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [
    MatSidenavModule,
    SidemenuComponent,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
  ],
  providers: [
    {
      provide: SIDEMENU_CONFIG,
      useValue: {
        menuItems: [
          {
            id: 'jobs',
            link: '/jobs',
            name: 'Aufträge',
            icon: 'format_list_bulleted',
            data: { roles: [AccessControlRole.Disponent, AccessControlRole.KFM] },
          },
          {
            id: 'users',
            link: '/users',
            name: 'Nutzer',
            icon: 'people',
          },
          {
            id: 'teams',
            link: '/teams',
            name: 'Teams',
            icon: 'groups',
          },
          {
            id: 'logout',
            link: '/logout',
            name: 'Logout',
            icon: 'logout',
            data: { roles: [AccessControlRole.Disponent, AccessControlRole.KFM, AccessControlRole.Inspector] },
          },
        ],
      },
    },
  ],
})
export class LayoutComponent {
}
